export default {
  en: {
    title: 'IP Restrictions',
    subtitle: 'Restrict access to users by IP ranges.',
    columns: {
      ip: 'IP Address',
      users: 'Users',
    },
    form: {
      infoAlert: {
        message: 'Search information',
        description: 'Can you search by first, last name, username or email, writing in the input.',
      },
      ip: {
        error: 'Enter a valid IP',
        hint: 'This is the IP range that your user will need to use to access. CIDR notation compatible.',
      },
    },
  },
  es: {
    title: 'Restricciones por IP',
    subtitle: 'Restringa el acceso de sus usuarios a determinadas IP.',
    columns: {
      ip: 'Dirección IP',
      users: 'Usuarios',
    },
    form: {
      infoAlert: {
        message: 'Información de búsqueda',
        description: 'Podrás buscar por nombre, apellido, nombre de usuario o email del agente, en la caja de selección.',
      },
      ip: {
        error: 'Por favor ingrese una IP válida.',
        hint: 'Esta es el rango IPs que su usuario deberá usar para acceder. Notación CIDR es compatible.',
      },
    },
  },
  fr: {
    title: 'Restrictions par IP',
    subtitle: 'Restreignez l\'accès de vos utilisateurs à certaines IP.',
    columns: {
      ip: 'Adresse IP',
      users: 'Utilisateurs',
    },
    form: {
      infoAlert: {
        message: 'Informations de recherche',
        description: 'Vous pourrez rechercher par nom, prénom, nom d\'utilisateur ou email de l\'agent, dans la boîte de sélection.',
      },
      ip: {
        error: 'Veuillez entrer une IP valide.',
        hint: 'C\'est l\'IP que votre utilisateur devra utiliser pour accéder. CIDR pas supportée.',
      },
    },
  }

};
